import React from "react";
import "../fieldComponent.css";
import "./StringInput.css";
import Title from "../Title";

/**
 * @param {String} placeholder the placeholder to display when input is empty
 *
 * @param {Function} handleOnChange when input changes
 */
const StringInput = props => {
  const {
    name,
    required,
    placeholder,
    handleChange,
    value,
    fieldValid,
    setFieldValid,
    type,
    info,
    isDisabled,
    styles,
    wrapperStyles,
    titleStyle,
    iconStyles,
    maxLength,
    onFocus,
    onBlur,
    suggestion
  } = props;

  return (
    <div style={wrapperStyles}>
      <Title
        name={name}
        required={required}
        info={info}
        titleStyle={titleStyle}
        iconStyles={iconStyles}
      />

      <div style={{ position: 'relative', width: '100%' }}>
        <input
          type={type || "text"}
          disabled={isDisabled || false}
          value={value}
          style={styles}
          onChange={e => {
            e.persist();
            handleChange(e);
            setFieldValid(true);
          }}
          onFocus={onFocus}
          onBlur={onBlur}
          maxLength={maxLength}
          onWheel={e => e.target.blur()}
          placeholder={placeholder}
          className={`string-input-field field-component-input-box ${
            fieldValid ? "" : "string-input-invalid"
          }`}
        />
        
        {/* Price Suggestion Pop Up*/}
        {suggestion && (
          <div className="price-suggestion-bubble">
            <div className="bubble-arrow"></div>
            <div className="bubble-content">
              {suggestion.isLoading ? (
                <div className="suggestion-loading">
                  <div className="spinner"></div>
                  <span>Suggesting...</span>
                </div>
              ) : (
                <>
                  <div className="bubble-body">
                    {suggestion.price && (
                      <>
                        <div className="suggested-price">
                          ${suggestion.price}
                        </div>
                        <div className="suggestion-reason">
                          {suggestion.reason}
                        </div>
                      </>
                    )}
                    
                    {suggestion.name && (
                      <div className="suggested-price">
                        {suggestion.name}
                      </div>
                    )}
                  </div>
                  <div className="bubble-actions">
                    <button 
                      className="bubble-apply-btn"
                      onClick={suggestion.onApply}
                    >
                      Use
                    </button>
                    <button 
                      className="bubble-dismiss-btn"
                      onClick={suggestion.onDismiss}
                    >
                      No Thanks
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default StringInput;
